import React, { useEffect, useRef, useState } from "react";

import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import {
  activeList,
  classSection,
  classSylabus,
} from "../../../core/common/selectoption/selectoption";
import CommonSelect from "../../../core/common/commonSelect";
import { Link } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import UserService from "../../network/services/UserService";
import { getUser } from "../../network/auth/Auth";
import { Modal, Toast } from "react-bootstrap";
import Select, { GroupBase } from "react-select";


const CourseFees = () => {
  const routes = all_routes;


  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const route = all_routes

  const multiselectwithplaceholder = [
    { value: "fr-1", label: "Apple" },
    { value: "fr-2", label: "Mango" },
    { value: "fr-3", label: "Orange" },
    { value: "fr-4", label: "Guava" },
    { value: "fr-5", label: "Pineapple" },
  ];
  const evaluationTypes = [{ value: 'normal', label: 'Normal' }, { value: 'GPA', label: 'GPA' },
  { value: 'CWA', label: 'CWA' }, { value: 'CCE', label: 'CCE' }];


  interface CourseFeesData {
    id: any;
    name: any;
    standard_price: any;
    lst_price: any;
    detailed_type: any,
    company_id: any

  }
  interface Option {
    id: any;
    name: any;
  }


  const [isActionSuccessful, setIsActionSuccessful] = useState(false);
  const [isActionSuccessfulEdit, setIsActionSuccessfulEdit] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showDangerToast, setShowDangerToast] = useState(false);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<any>({
    name: '',
    standard_price: '',
    company_id: ''
  });




  const handleSuccessToastClose = () => {
    setShowSuccessToast(false);
  };

  const handleDangerToastClose = () => {
    setShowDangerToast(false);
  };

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const handleClose2 = () => setShowModal2(false);
  const handleShow2 = () => setShowModal2(true);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowDangerToast(false);
    }, 3000);
    return () => clearTimeout(timeoutId);
  }, [showDangerToast]);


  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setShowSuccessToast(false);
    }, 4000);
    return () => clearTimeout(timeoutId);
  }, [showSuccessToast]);

  const [formData, setFormData] = useState({
    name: '',
    standard_price: '',
    company_id: ''
  });

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleInputChangeEdite = (e: any) => {
    const { name, value } = e.target;
    setSelectedRecord((prevRecord: any) => ({
      ...prevRecord,
      [name]: value
    }));
  };

  const handleInputChangeEdite2 = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    const selectedBranch = branches.find((branch: any) => branch.id === parseInt(value, 10));

    if (selectedBranch) {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        operating_branch_id: [selectedBranch],
      }));
    }
  };

  const handleInputChangeEdite3 = (selectedOptions: any) => {
    if (selectedOptions) {
      const selectedSubjects = selectedOptions.map((option: any) => ({
        id: option.value,
        name: option.label,
      }));

      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: selectedSubjects,
      }));
    } else {
      setSelectedRecord((prevState: any) => ({
        ...prevState,
        subject_ids: [],
      }));
    }
  };



  const handleSelectChange = (selectedOption: any, actionMeta: any) => {

    setFormData({
      ...formData,
      [actionMeta.name]: selectedOption
    });
  };


  const [multiSubject, setMultiSubject] = useState<OptionType[]>([]);

  const handleEdit = (record: any) => {
    setSelectedRecord(record)
    handleShow2()
    console.log(record)

  };




  const handleSubmit = () => {
    setIsLoading(true)

    const request_data = {
      name: formData.name,
      standard_price: parseFloat(formData.standard_price),
      company_id: getUser()?.company_ids[0]?.id,
    };

    UserService.addCourseFees(request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.id);
        setIsLoading(false)
        setIsActionSuccessful(true)
        setSuccessMessage('Data saved successfully')
        setShowSuccessToast(true)
        setFormData({
          name: '',
          standard_price: '',
          company_id: ''
        });

        setShowModal(false);

      } else {
        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };

  const handleSubmitEdit = () => {
    console.log(selectedRecord)


    const array_subjects_ids: any[] = selectedRecord.subject_ids ? selectedRecord.subject_ids.map((item: any) => parseInt(item.id, 10)) : [];
    setIsLoading(true)
    const request_data = {
      name: selectedRecord.name,
      standard_price: parseFloat(selectedRecord.lst_price),
      company_id: getUser()?.company_ids[0]?.id,
    };
    console.log(request_data)


    UserService.editCourseFees(selectedRecord?.id, request_data, (response: any) => {
      if (response.data && response.success) {
        fetchData(getUser()?.company_ids[0]?.id);
        setIsLoading(false)
        setIsActionSuccessfulEdit(true)

        setFormData({
          name: '',
          standard_price: '',
          company_id: ''
        });
        handleClose2()
      } else {
        setFormData({
          name: '',
          standard_price: '',
          company_id: ''
        });
        setErrorMessage('An error has occurred, please try again.')
        setShowDangerToast(true)
        setIsLoading(false)
      }
    });
  };

  const formatDate = (date: Date | string) => {
    if (!date) return '';

    const d = new Date(date);
    const month = `${d.getMonth() + 1}`.padStart(2, '0');
    const day = `${d.getDate()}`.padStart(2, '0');
    const year = d.getFullYear();

    return `${year}-${month}-${day}`;
  };

  const [coursesFees, setCoursesFees] = useState<CourseFeesData[]>([]);
  const [branch, setBranch] = useState<Option>(getUser()?.company_ids[0]?.branches[0]);
  const branches = getUser()?.company_ids[0]?.branches;



  const fetchData = async (company_id: any) => {
    UserService.getCourseFees(company_id, (response: any) => {
      if (response?.data && response?.success) {
        setCoursesFees(response.data);
      }
    });
  };

  useEffect(() => {
    fetchData(getUser()?.company_ids[0]?.id);
  }, []);



  interface OptionType {
    label: string;
    value: number;
  }

  const [subjects, setSubjects] = useState<OptionType[]>([]);
  // Fonction pour mettre à jour les sujets


  const fetchDataSubjects = async (company_id: any) => {
    UserService.getSubjectsByBranchAndComapny2(company_id, (response: any) => {
      if (response?.data && response?.success) {
        const subjectsAsOptions: OptionType[] = response.data.map((subject: any) => ({
          value: subject.id,

          label: subject.name,
        }));
        // Appel de la fonction setAllSubjects
        setSubjects(subjectsAsOptions);
      }
    });
  };

  useEffect(() => {
    fetchDataSubjects(getUser()?.company_ids[0]?.id);
  }, []);














  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <Link to="#" className="link-primary">
            {record.id}
          </Link>
        </>
      ),
    },

    {
      title: "Name",
      dataIndex: "name",
      sorter: (a: CourseFeesData, b: CourseFeesData) => a.name.length - b.name.length,
    },
    {
      title: "Cost",
      dataIndex: "lst_price",
      sorter: (a: CourseFeesData, b: CourseFeesData) =>
        a.lst_price.length - b.lst_price.length,
    },
    {
      title: "Product Type",
      dataIndex: "detailed_type",
      sorter: (a: CourseFeesData, b: CourseFeesData) =>
        a.detailed_type.length - b.detailed_type.length,
    },
    {
      title: "Action",
      render: (record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    onClick={() => handleEdit(record)}
                  >
                    <i className="ti ti-edit-circle me-2" />
                    Edit
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item rounded-1"
                    to="#"
                    data-bs-toggle="modal"
                    data-bs-target="#delete-modal"
                  >
                    <i className="ti ti-trash-x me-2" />
                    Delete
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];
  return (
    <div>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Course fees List</h3>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={route.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Course fees </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Course fees
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              {getUser().role === "school_admin" && (<div className="mb-2">
                <Link to="#" className="btn btn-primary d-flex align-items-center" onClick={handleShow}>
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Course fees
                </Link>

              </div>)}

            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Course fees List</h4>
              <div className="d-flex align-items-center flex-wrap">
                <div className="input-icon-start mb-3 me-2 position-relative">
                  <PredefinedDateRanges />
                </div>
                <div className="dropdown mb-3 me-2">
                  <Link
                    to="#"
                    className="btn btn-outline-light bg-white dropdown-toggle"
                    data-bs-toggle="dropdown"
                    data-bs-auto-close="outside"
                  >
                    <i className="ti ti-filter me-2" />
                    Filter
                  </Link>
                  <div className="dropdown-menu drop-width" ref={dropdownMenuRef}>
                    <form >
                      <div className="d-flex align-items-center border-bottom p-3">
                        <h4>Filter</h4>
                      </div>
                      <div className="p-3 border-bottom pb-0">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Class</label>
                              <CommonSelect
                                className="select"
                                options={classSylabus}
                                defaultValue={classSylabus[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Section</label>
                              <CommonSelect
                                className="select"
                                options={classSection}
                                defaultValue={classSection[0]}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-3">
                              <label className="form-label">Status</label>
                              <CommonSelect
                                className="select"
                                options={activeList}
                                defaultValue={activeList[0]}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="p-3 d-flex align-items-center justify-content-end">
                        <Link to="#" className="btn btn-light me-3">
                          Reset
                        </Link>
                        <Link
                          to="#"
                          className="btn btn-primary"
                          onClick={handleApplyClick}
                        >
                          Apply
                        </Link>
                      </div>
                    </form>
                  </div>
                </div>

              </div>
            </div>
            <div className="card-body p-0 py-3">
              {/* Guardians List */}
              <Table columns={columns} dataSource={coursesFees} Selection={true} />
              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      ;{/* /Page Wrapper */}
      <>


        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form >
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-danger" data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}







        <Modal show={showModal} onHide={handleClose} >
          <Modal.Header >
            <Modal.Title>Add Course fees</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={formData.name}
                        onChange={handleInputChange} />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Cost</label>
                      <input type="number" className="form-control" name="standard_price"
                        value={formData.standard_price}
                        onChange={handleInputChange} />
                    </div>


                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose}
                >
                  Cancel
                </span>
                <a className="btn btn-primary" onClick={handleSubmit}  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Add Course fees"}

                </a>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Modal show={showModal2} onHide={handleClose2} >
          <Modal.Header >
            <Modal.Title>Edit Course fees</Modal.Title>
            <button
              type="button"
              className="btn-close custom-btn-close"
              onClick={handleClose2}

            >
              <i className="ti ti-x" />
            </button>
          </Modal.Header>
          <Modal.Body>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" placeholder="Name" name="name" value={selectedRecord?.name}
                        onChange={handleInputChangeEdite} />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Cost</label>
                      <input type="number" className="form-control" name="lst_price"
                        value={selectedRecord.lst_price}
                        onChange={handleInputChangeEdite} />
                    </div>

                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <span
                  className="btn btn-light me-2"
                  onClick={handleClose2}
                >
                  Cancel
                </span>
                <Link to="#" className="btn btn-primary" onClick={handleSubmitEdit}  >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm align-middle me-1"
                        role="status"
                        aria-hidden="true"
                      />
                      Loading...
                    </>
                  ) : "Edit Course fees"}

                </Link>
              </div>
            </form>
          </Modal.Body>

        </Modal>

        <Toast
          show={showDangerToast}
          onClose={handleDangerToastClose}
          id="dangerToast"
          className="toast-container position-fixed top-0 end-0 p-3 colored-toast bg-danger-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
          style={{ minWidth: "200px!important" }}
        >
          <Toast.Header closeButton className="bg-danger text-fixed-white">
            <strong className="me-auto">Message</strong>
            <span
              className="cursor-pointer"
              onClick={handleDangerToastClose}
              aria-label="Close"
              style={{ cursor: "pointer" }}
            />
          </Toast.Header>
          <Toast.Body>
            {/* Add your toast content here */}
            {errorMessage}
          </Toast.Body>
        </Toast>

        <Toast
          show={showSuccessToast}
          onClose={handleSuccessToastClose}
          id="successToast"
          className="toast-container position-fixed top-0 end-0 p-3  colored-toast bg-success-transparent"
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >

          <Toast.Body>
            {/* Add your toast content here */}
            {successMessage}
          </Toast.Body>
        </Toast>

      </>
    </div>
  );
};

export default CourseFees;
